import * as Yup from 'yup'

export const specialIcashRefundTxSchemas = Yup.object().shape({
  creditValue: Yup.number().required(),
  externalTransactionId: Yup.number().required(),
  ident: Yup.string().required(),
  storeId: Yup.number(),
  cashier: Yup.string().optional(),
  guid: Yup.string().optional(),
  comments: Yup.string().optional(),
  traceNumber: Yup.number().optional(),
  reasonId: Yup.number().optional(),
})